import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactSelect5, { Option } from '@/components/common/ReactSelect5';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';
import ArrowNavigator from './ArrowNavigator';

const QuestionNavigator = () => {
  const { assignment, classroom, questionId, setGradingStore } = useGradingStore();
  const { question_data_for_navigation: questionData, questions } = assignment;
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const lessonId = searchParams.get('lesson_id');

  const [currentQuestion, setCurrentQuestion] = useState<Option>(null);

  const navigableOptions = [];
  const dropdownOptions = [];
  questionData.forEach((question) => {
    const questionOption: Option = {
      className: question.disabled ? 'tw-font-bold !tw-text-very-dark-grey' : '',
      isDisabled: question.disabled,
      label: question.label,
      value: question.value.toString(),
    };
    if (!question.disabled) navigableOptions.push(questionOption);
    dropdownOptions.push(questionOption);
  });

  useEffect(() => {
    const question = questions.find(q => q.id === questionId);
    setCurrentQuestion({
      label: question.body,
      value: question.id.toString(),
    });
  }, [questionId, questions]);

  const onQuestionChange = (value: string) => {
    const newQuestionId = parseInt(value, 10);
    setGradingStore({ questionId: newQuestionId });
    navigate(`/${assignment.id}/questions/${newQuestionId}?classroom_id=${classroom.id}&lesson_id=${lessonId}`);
  };

  const label = 'Question';
  const toggleId = 'question-toggle';

  return (
    <ArrowNavigator
      currentValue={questionId.toString()}
      isDisabled={navigableOptions.length <= 1}
      label={label}
      labelClass="tw-text-xs"
      navigableOptions={navigableOptions}
      toggleId={toggleId}
      onChange={onQuestionChange}
    >
      <ReactSelect5
        classNames={{ option: (state: any) => state.data.className || '' }}
        id={toggleId}
        options={dropdownOptions}
        value={currentQuestion}
        onChange={(opt: Option) => onQuestionChange(opt.value)}
      />
    </ArrowNavigator>
  );
};

export default QuestionNavigator;
